import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    spirotech_user_agreement_part1: {
      id: 'spirotech_user_agreement_part1',
      defaultMessage: "I consent to having my personal data contained in the registration form processed as stated in the posted",
      description: '',
    },
    spirotech_user_agreement_part2: {
      id: 'spirotech_user_agreement_part2',
      defaultMessage: " privacy statement",
      description: '',
    },
    husty_user_agreement: {
      id: 'husty_user_agreement',
      defaultMessage: "I consent to having my personal data contained in the registration form of SaoCal  water treatment system Internet service processed by Husty M.Styczeń, J.Hupert sp. j. registered in Krakow [ul. Rzepakowa 5E, 31-989 Kraków, entered in the Register of Entrepreneurs kept by the District Court for Kraków-Śródmieście District in Krakow, 9th Commercial Department of the National Court Register, entry no. KRS 91562, Tax ID No. NIP 6770082043, Business Statistical No. REGON 350690189] for the purpose and to the extent required to complete the registration process in the service and operate the account created in the service.",
      description: '',
    },
    field_max_length_25: {
      id: 'field_max_length_25',
      defaultMessage: "Field must be a maximum 25 characters length",
      description: '',
    },
    field_max_length_40: {
      id: 'field_max_length_40',
      defaultMessage: "Field must be a maximum 40 characters length",
      description: '',
    },
    field_min_length_8: {
      id: 'field_min_length_8',
      defaultMessage: "Field must be a minimum 8 characters length",
      description: '',
    },
    field_must_be_an_email: {
      id: 'field_must_be_an_email',
      defaultMessage: "Field has to be an email",
      description: '',
    },
    register_now_login_text: {
      id: 'register_now_login_text',
      defaultMessage: "Register now",
      description: '',
    },
    password_register_text: {
      id: 'password_register_text',
      defaultMessage: "Password",
      description: '',
    },
    email_placeholder_register_text: {
      id: 'email_placeholder_register_text',
      defaultMessage: "Enter a valid email address",
      description: '',
    },
    language_register_text: {
      id: 'language_register_text',
      defaultMessage: "Language",
      description: '',
    },
    account_type_register_text: {
      id: 'account_type_register_text',
      defaultMessage: "Account type",
      description: '',
    },
    register_submit_button_text: {
      id: 'register_submit_button_text',
      defaultMessage: "Register",
      description: '',
    },
    link_sent_account_created_info_text: {
      id: 'link_sent_account_created_info_text',
      defaultMessage: "Activation link has been sent to your email.",
      description: '',
    },
    login_or_email_already_registerd_info_text: {
      id: 'login_or_email_already_registerd_info_text',
      defaultMessage: "Login or email adress already exists in the database",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/RegisterForm/Messages.js